import { Textarea } from '~/primitives/input';
import { useFieldContext } from '~/util/hooks/useFormContext';
import { FieldLabelWithError } from './FieldLabelWithError';
import type { FieldWithErrorProps } from './FieldLabelWithError';
import { cn } from '~/util';
import { useDisableFormContext } from '../DisableContext';

export function TextAreaField({
    placeholder,
    classname,
    ...labelProps
}: {
    placeholder: string;
    classname?: string;
} & FieldWithErrorProps) {
    const field = useFieldContext<string | null>();
    const disabled = useDisableFormContext();
    return (
        <FieldLabelWithError<string | null> {...labelProps}>
            <Textarea
                className={cn(
                    'field-sizing-content max-w-lg',
                    disabled && 'opacity-50 cursor-not-allowed',
                    classname,
                )}
                id={field.name}
                disabled={disabled}
                placeholder={placeholder}
                required={labelProps.required}
                value={field.state.value ?? ''}
                onChange={(e) =>
                    field.setValue(
                        e.target.value === '' ? null : e.target.value,
                    )
                }
            />
        </FieldLabelWithError>
    );
}
